// ** Type Import
import { OwnerStateThemeType } from "../";

const Pagination = () => {
  return {
    MuiPaginationItem: {
      styleOverrides: {
        outlined: ({ theme }: OwnerStateThemeType) => ({}),
        outlinedPrimary: ({ theme }: OwnerStateThemeType) => ({}),
        outlinedSecondary: ({ theme }: OwnerStateThemeType) => ({}),
      },
    },
  };
};

export default Pagination;
